import { useState, useEffect, createContext } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";

const AssessmentQuestionContext = createContext({
  questions: {},
  assessmentId: 0,
  setAssessmentId: (setAssessmentId) => { },
  addQuestions: (addQuestions) => { },
  updateAnswer: (updateAnswer) => { },
  updateAllQuestions: (updateAllQuestions) => { },
  updateTextAnswer: (updateTextAnswer) => { },
  backPageInfo: {
    currentPage: 0,
    previousPage: 0
  },
  isFetched: false
});

export function AssessmentQuestionContextProvider(props) {
  const location = useLocation();
  const [assessmentId, setAssessmentId] = useState();
  const [questions, setQuestions] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [savedProgress, setSavedProgress] = useState([]);
  const [isFetched, setIsFetched] = useState(false);
  const [leaderName, setLeaderName] = useState(false)
  const [orgId, setOrgId] = useState();
  const [clientId, setClientId] = useState()

  useEffect(() => {
    const storedQuestions = JSON.parse(localStorage.getItem(`allQuestions-${assessmentId}`));
    if (storedQuestions) {
      setAllQuestions(storedQuestions);
      setIsFetched(true);
    }
  }, [assessmentId]);

  useEffect(() => {
    if (location.pathname.split("/").includes("review")) {
      let localStoredQuestions = JSON.parse(localStorage.getItem("assessmentAnswers"));
      if (localStoredQuestions?.length) {
        setQuestions(localStoredQuestions);
        setIsFetched(true);
      }
    }
  }, [location]);

  function addQuestionsHandler(data) {
    setQuestions(data);
  }

  function updateAnswerHandler(questionId, answer) {
    let question = questions.find(obj => obj.id == questionId);
    if (questions.answer) question.answer = answer;
    let localQuestions = [];
    questions.forEach(q => localQuestions.push(q));
    localStorage.setItem('assessmentAnswers', JSON.stringify(localQuestions));
  }

  function updateTextAnswerHandler(questionId, answer) {
    let question = questions.find(obj => obj.id == questionId);
    if (question) {
      question.answerTxt = answer;
    }
    let localQuestions = [];
    questions.forEach(q => localQuestions.push(q));
    localStorage.setItem('assessmentAnswers', JSON.stringify(localQuestions));
  }

  const updateAllQuestionsHandler = (pageId, questionArray, isMost, mostScores, leastScores) => {
    const pageIdArray = allQuestions?.map((el) => ({ pageId: el?.pageId, isMost: el?.isMost }));
    const currentPageIdObj = pageIdArray?.find((el) => el?.pageId == pageId);
    const currentPageIdIsMostObj = pageIdArray?.find((el) => el?.pageId == pageId && el?.isMost == isMost);

    if ((currentPageIdObj?.pageId !== pageId) || (currentPageIdObj?.pageId == pageId && currentPageIdObj?.isMost == true && isMost == false)) {
      setAllQuestions([
        ...allQuestions,
        {
          pageId,
          data: questionArray,
          isMost,
          mostScores,
          leastScores
        }
      ]);
    } else {
      let lsIsMost = localStorage?.getItem(`isMost-${assessmentId}`);
      let currentPageIdIndexObj = pageIdArray?.find((el) => el.pageId == pageId);
      let currentPageIdIndex = pageIdArray?.indexOf(currentPageIdIndexObj);
      let tempAllQuestions = [...allQuestions]?.filter((el, index) => index <= currentPageIdIndex);
      let tempPageIdArray = tempAllQuestions.find((el) => el?.pageId === pageId);

      if (tempPageIdArray) {
        const updatedElement = { ...tempPageIdArray, data: questionArray };
        tempAllQuestions = tempAllQuestions.map((el) =>
          el?.pageId === pageId ? updatedElement : el
        );
      }

      setAllQuestions(tempAllQuestions);
    }
  };

  useEffect(() => {
    // console.log("allQuestions---",allQuestions)
    const filteredQuestions = allQuestions?.filter((el) => el !== null )
    // console.log("allQuestions---",filteredQuestions)

    // localStorage.setItem(`allQuestions-${assessmentId}`, JSON.stringify(filteredQuestions));
    localStorage.setItem(`allQuestions-${assessmentId}`, JSON.stringify(allQuestions));
  }, [allQuestions, questions]);

  const context = {
    questions: questions,
    allQuestions: allQuestions,
    savedProgress: savedProgress,
    isFetched: isFetched,
    setIsFetched: setIsFetched,
    setAllQuestions: setAllQuestions,
    addQuestions: addQuestionsHandler,
    assessmentId: assessmentId,
    setAssessmentId: setAssessmentId,
    updateAllQuestions: updateAllQuestionsHandler,
    updateAnswer: updateAnswerHandler,
    updateTextAnswer: updateTextAnswerHandler,
    leaderName,
    setLeaderName,
    setOrgId,
    orgId,
    clientId,
    setClientId
  };

  return (
    <AssessmentQuestionContext.Provider value={context}>
      {props.children}
    </AssessmentQuestionContext.Provider>
  );
}

export default AssessmentQuestionContext;
